"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const data_1 = require("../engine/data");
const scenario_type_service_1 = require("./scenario-type-service");
const scenario_calculation_service_1 = require("./scenario-calculation-service");
function modifyPopulationByScenario(model, population, scenario) {
    return modifyPopulationByScenarios(model, population, [scenario]);
}
exports.modifyPopulationByScenario = modifyPopulationByScenario;
function modifyPopulationByScenarios(model, population, scenarios) {
    // Clone population because we'll be modifying it for processing
    const clonedPopulation = lodash_1.cloneDeep(population);
    // Iterate over population to calculate prevalences and add any missing fields
    const variablePrevalenceMap = preprocessPopulationForScenarios(clonedPopulation, scenarios, model);
    // Modify population according to scenarios
    applyScenarioChanges(clonedPopulation, scenarios, variablePrevalenceMap);
    return clonedPopulation;
}
exports.modifyPopulationByScenarios = modifyPopulationByScenarios;
/**
 * @description Prepare a population for modification by scenarios. Ensure all variables in every scenario
 * exists for every individual, and create them if they don't. Create a map of every variable and their
 * prevalences
 * @param population Population
 * @param scenarios Scenarios
 * @param model Model
 */
function preprocessPopulationForScenarios(population, scenarios, model) {
    const variablePrevalenceMap = {};
    population.forEach(individual => {
        const algorithm = model.getAlgorithmForData(individual);
        scenarios.forEach(scenario => {
            const sexConfig = scenario_calculation_service_1.getScenarioConfigForSex(individual, scenario);
            sexConfig.variables.forEach(variable => {
                const { variableName } = variable;
                /* Try to find datum. If it doesn't exist, the field must be a derived field, and
                    should be added to the individual. Do this with the absorbing variable too */
                addVariableIfMissing(individual, algorithm, variableName);
                // Increment the prevalence of this variable if individual is exposed
                if (scenario_calculation_service_1.shouldModifyVariable(individual, variable)) {
                    if (scenario_type_service_1.isCategoricalMethod(variable)) {
                        const { absorbingVariable } = variable;
                        const prevalence = variablePrevalenceMap[variableName] || 0;
                        variablePrevalenceMap[variableName] = prevalence + 1;
                        addVariableIfMissing(individual, algorithm, absorbingVariable);
                    }
                    else if (scenario_type_service_1.isComponentMethod(variable)) {
                        addVariableIfMissing(individual, algorithm, variable.parentVariable);
                    }
                }
            });
        });
    });
    // Update prevalences to percentages
    Object.keys(variablePrevalenceMap).forEach(variable => (variablePrevalenceMap[variable] =
        variablePrevalenceMap[variable] / population.length));
    return variablePrevalenceMap;
}
/**
 * @description If a variable for an individual doesn't exist, create it and calculate its value
 * @param individual Individual
 * @param algorithm Algorithm
 * @param variable Variable to add if doesn't already exist
 */
function addVariableIfMissing(individual, algorithm, variable) {
    try {
        data_1.findDatumWithName(variable, individual);
    }
    catch (e) {
        const missingVariable = algorithm.findDataField(variable);
        individual.push({
            name: variable,
            coefficent: missingVariable.calculateCoefficent(individual, algorithm.userFunctions, algorithm.tables),
        });
    }
}
/**
 * @description Modify population based on scenario configurations
 * @param population Population to modify
 * @param scenarios Scenarios
 * @param variablePrevalenceMap Map of variables and their prevalences
 */
function applyScenarioChanges(population, scenarios, variablePrevalenceMap) {
    population.forEach(individual => scenarios.forEach(scenario => {
        const sexConfig = scenario_calculation_service_1.getScenarioConfigForSex(individual, scenario);
        const scenarioVariablesToModify = sexConfig.variables.filter(variable => scenario_calculation_service_1.shouldModifyVariable(individual, variable));
        scenarioVariablesToModify.forEach(scenarioVariable => {
            const targetVariable = data_1.findDatumWithName(scenarioVariable.variableName, individual);
            if (scenario_type_service_1.isCategoricalMethod(scenarioVariable)) {
                const targetVariablePrevalence = variablePrevalenceMap[scenarioVariable.variableName];
                const relativeChange = scenario_calculation_service_1.calculateRelativeChange(scenarioVariable, targetVariablePrevalence);
                const absorbingVariable = data_1.findDatumWithName(scenarioVariable.absorbingVariable, individual);
                targetVariable.coefficent = String(Number(targetVariable.coefficent) *
                    (1 - relativeChange));
                absorbingVariable.coefficent = String(Number(absorbingVariable.coefficent) * relativeChange);
            }
            else if (scenario_type_service_1.isComponentMethod(scenarioVariable)) {
                scenario_calculation_service_1.runVariableMethodComponent(individual, scenarioVariable, targetVariable);
            }
            else {
                scenario_calculation_service_1.runVariableMethodContinuous(scenarioVariable, targetVariable);
            }
            scenario_calculation_service_1.applyPostScenarioRange(targetVariable, scenarioVariable);
        });
    }));
}
//# sourceMappingURL=modify-population.js.map